import * as React from 'react';
import { CaseComponent } from "../Case";
import { Row, Button, Label } from 'reactstrap';
import Col from 'reactstrap/lib/Col';
import { Form } from 'src/share/components/Form/Form';
import { CaseForm } from '../components/CaseForm';
import { CircumstancesForm } from '../components/CircumstancesForm';
import { PersonInfoForm } from '../components/PersonInfoForm';
import { BeatLoader, PulseLoader } from 'react-spinners';
import MiscellaneousForm from '../components/MiscellaneousForm';
import ConfirmationModal from '../../../../share/components/ConfirmationModal/ConfirmationModal';
import { ETLHelper } from 'src/share/components/ETLHelper/ETLHelper';
import PerfectScrollbar from "perfect-scrollbar-react";

const Header = (propsp) => (
    <Row>
        <Col md={12}>
            <h5 className="header">{propsp.children}</h5>
        </Col>
    </Row>
)
const Title = ({ that, caseInfo }) => (
    <Row>
        <Col md={12}>
            <h3>
                {that.isEditCase() ? `${that.getCaseId(window.location.pathname)}` : "Add new case"}
            </h3>
            <ETLHelper etl={caseInfo.etl} />
        </Col>
    </Row>
)
const Case = ({ that, loading, readOnly, caseInfo, isEditCase }) => (
    <CaseForm
        auth={that.props.auth}
        caseIdStatus={that.state.caseIdStatus} setCaseIdStatus={that.setCaseIdStatus}
        isEditCase={isEditCase} caseInfo={caseInfo} setValue={that.setValue}
        form={that.form} agencies={that.props.auth.agencies} disabled={readOnly || loading}
    />
)
const Circumstances = ({ that, loading, readOnly, caseInfo, submitted, isEditCase }) => (
    <CircumstancesForm
        disabled={loading || readOnly} caseInfo={caseInfo} setValue={that.setValue}
        form={that.form} submitted={submitted} isEditCase={isEditCase}
    />
)
const Children = ({ that, loading, readOnly, caseInfo }) => (
    <PersonInfoForm
        type="child" form={that.form} ius={that.state.imageUploadingStatus}
        disabled={loading || readOnly} setValue={that.setValue} personsInfo={caseInfo.children}
        addPerson={that.person.addPerson} removePerson={that.person.removePerson}
        isEdit={that.isEditCase()}
    />
)
const Abductor = ({ that, loading, readOnly, caseInfo }) => (
    <PersonInfoForm
        type="abductor" form={that.form} ius={that.state.imageUploadingStatus}
        disabled={loading || readOnly} setValue={that.setValue} personsInfo={caseInfo.abductors}
        addPerson={that.person.addPerson} removePerson={that.person.removePerson}
        isEdit={that.isEditCase()}
    />
)
const Miscellaneous = ({ that, loading, readOnly, isAnETLCase }) => (
    <MiscellaneousForm
        ius={that.state.imageUploadingStatus}
        setValue={that.setValue}
        disabled={loading || readOnly || isAnETLCase}
        images={that.state.caseInfo.miscellaneous}
    />
)
const Buttons = ({ that }: { that: CaseComponent }) => (
    <Row>
        <Col md="5">
            <p className="required">*Required field</p>
        </Col>
        <Col md="2" className="offset-1 text-center btn-underline">

            {
                that.isEditCase() && !that.wasClose() && !that.state.loading
                && that.props.permissionCase !== false && !that.props.isAnETLCase &&
                <Button onClick={that.modalToggle} block={true} className="btn btn-outline float-right btn-grey-fill">
                    Delete
                </Button>
            }
        </Col>
        <Col md="2" className="text-center">
            {
                that.isEditCase() && !that.wasClose() && !that.state.loading
                && that.props.permissionCase !== false && !that.props.isAnETLCase &&
                <Button onClick={that.closeCase} block={true} className="btn btn-outline float-right btn-grey-fill">
                    Close
                </Button>
            }
        </Col>
        <Col md="2" className="text-center">
            {renderSubmitView(that)}
            {
                that.isEditCase() && that.wasClose() && !that.state.loading &&
                <Button onClick={that.modalToggle} block={true} className="btn btn-underline float-right actionBtn">
                    Delete
                </Button>
            }
        </Col>
        <ConfirmationModal
            isOpen={that.state.isModalOpen}
            toggle={that.modalToggle}
            title={`Delete Case #${that.props.match.params.caseId}`}
            description="Are you sure you want to delete this case?"
            onContinue={() => {
                that.modalToggle();
                that.delete(that.props.match.params.caseId)
            }}
        />
    </Row>
)
const AdvancedLayout = (props: { that, loading, readOnly, caseInfo, isEditCase, submitted, isAnETLCase }) => (
    <>
        <Row>
            <Col md={12} className="container-padding">
                <Title {...props} />
            </Col>
        </Row>
        <Row>
            <Col md={6} className="container-padding">
                <Header>Case info</Header>
                <Case  {...props} />
            </Col>
            <Col md={6} className="container-padding">
                <Header>Missing info</Header>
                <Circumstances  {...props} />
            </Col>
        </Row>
        <Row>
            <Col md={12} className="container-padding">
                <Header>Miscellaneous</Header>
                <Miscellaneous  {...props} />
            </Col>
        </Row>
        <Row>
            <Col md={6} className="container-padding">
                <Header>{props.caseInfo.children.length > 1 ? "Children's" : "Child's"} info </Header>
                <Children  {...props} />
            </Col>
            <Col md={6} className="container-padding">
                <Header>{props.caseInfo.abductors.length > 1 ? "Companions'" : "Companion's"} info</Header>
                <Abductor  {...props} />
            </Col>
        </Row>
        <Buttons {...props} />
    </>
)

export const CaseContainer = ((props) => {
    const that: CaseComponent = props.that;
    const { loading, component } = that.state;


    return (
        <PerfectScrollbar>
            <div className="case ">
                <div className={"content white-background"}>
                    <Form key={component} onInvalidSubmit={that.handleInvalidSubmit} onValidSubmit={that.handleValidSubmit} onSubmit={that.handleSubmit}>
                        {
                            <AdvancedLayout that={that} {...that.state} readOnly={that.isReadOnly()} isAnETLCase={that.props.isAnETLCase} />
                        }
                    </Form>
                    <div className="help-loader">
                        <BeatLoader loading={loading} />
                    </div>
                </div>

            </div>
        </PerfectScrollbar>
    )
})
const renderSubmitView = (that) => {
    return that.upload && that.upload.wasErrorsUploadingImages() ?
        <Button block={true} type="submit" id="retryBTN" className="btn btn-outline float-right reupload actionBtn" >
            Retry to upload the images
        </Button>
        : that.state.loading ?
            <>
                <Label id="loadingText" className="text-center saving-text">{that.state.loadingMessage}</Label>
                <PulseLoader size={15} color={'#db8733'} loading={that.state.loading} />
            </>
            : that.isReadOnly() && !that.props.isAnETLCase ?
                <>
                </>
                :
                <Button block={true} type="submit" id="submitBTN" className="btn btn-outline float-right btn-green-fill">
                    Submit
            </Button>
}


// WEBPACK FOOTER //
// ./src/modules/Case/Add/layouts/Case.tsx